<template>
  <AuthenticatedDashboard
    v-if="isDashboardRoute"
    :user="currentUser"
    @logout="handleLogout"
  />
  <HomeLanding v-else />
</template>

<script>
import './assets/css/reset.css'
import './styles/theme.css'
import { clearStoredAuth, hasAuthenticatedSession, loadStoredAuth, logoutUser } from './api/auth'
import { defineAsyncComponent } from 'vue'

const AuthenticatedDashboard = defineAsyncComponent(() => import('./components/AuthenticatedDashboard.vue'))
const HomeLanding = defineAsyncComponent(() => import('./components/HomeLanding.vue'))

export default {
  name: 'App',
  components: {
    AuthenticatedDashboard,
    HomeLanding,
  },
  data() {
    return {
      currentUser: loadStoredAuth(),
    }
  },
  computed: {
    isDashboardRoute() {
      const workspacePaths = [
        '/admin/users.html',
        '/about.html',
      ]
      return workspacePaths.includes(window.location.pathname) && hasAuthenticatedSession(this.currentUser)
    },
  },
  mounted() {
    window.addEventListener('timeimprint:unauthenticated', this.handleUnauthenticated)
  },
  beforeUnmount() {
    window.removeEventListener('timeimprint:unauthenticated', this.handleUnauthenticated)
  },
  methods: {
    handleUnauthenticated() {
      this.currentUser = null
      if (window.location.pathname !== '/') window.location.assign('/')
    },
    async handleLogout() {
      const token = this.currentUser?.token
      try {
        if (token) await logoutUser(token)
      } finally {
        clearStoredAuth()
        this.currentUser = null
        window.location.assign('/')
      }
    },
  },
}
</script>
